var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('div',[_c('GChart',{staticClass:"divChart",attrs:{"type":"PieChart","data":_vm.getChartData(),"options":_vm.getChartOptions()}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }